module.exports = __webpack_public_path__ + "img/farm_Mexico.43663ec8.jpg";